import { KeyboardArrowDown } from "@mui/icons-material";
import { SelectProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { forwardRef, useRef } from "react";
import { BybVrMenu, BybVrMenuItem, StyledSelect } from "./byb-vr-select.styled";

export { BybVrMenu, BybVrMenuItem };

export const BybVrSelect = forwardRef<HTMLDivElement, SelectProps>((props, ref) => {
  const theme = useTheme();
  const inputRef = useRef<any>(null);

  const handleChange = (event: any, child?: React.ReactNode) => {
    if (props.onChange) props.onChange(event, child);
  };

  const handleClose = (event: any) => {
    if (props.onClose) props.onClose(event);

    setTimeout(() => {
      inputRef.current?.blur?.();
    }, 0);
  };

  const defaultPaperSx = {
    backdropFilter: `blur(${theme.spacing(1.25)})`,
    backgroundColor: `${theme.palette.dsSurface.v100}80`,
    backgroundImage: "none",
    border: `1px solid ${theme.palette.dsSurface.v400}80`,
    boxShadow: "none",
    borderRadius: theme.spacing(1),
  } as const;

  const mergedMenuProps = {
    ...props.MenuProps,
    PaperProps: {
      ...(props.MenuProps?.PaperProps || {}),
      sx: [defaultPaperSx, props.MenuProps?.PaperProps?.sx].filter(Boolean),
    },
  } as SelectProps["MenuProps"];

  return (
    <StyledSelect
      {...props}
      onChange={handleChange}
      onClose={handleClose}
      inputRef={inputRef}
      MenuProps={mergedMenuProps}
      IconComponent={KeyboardArrowDown}
      ref={ref}
    />
  );
});
